import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import createPersistedState from "vuex-persistedstate";
import user from "./modules/user";
import workdata from "./modules/workdata";
import theme from "./modules/theme";
import schoolLogo from "./modules/schoolLogo";
import resource from "./modules/resource";
import globalCheck from "./modules/globalCheck";




Vue.use(Vuex);

const userStore = new Vuex.Store({
  modules: {
    user,
    workdata,
    theme,
    schoolLogo,
    resource,
    globalCheck,
  },
  getters,
  plugins: [
    createPersistedState({
      paths: ["user"],

    }),
  ],
});
export default userStore;
